<template>
 <div class="page">
  <div class="m-b-24 bg-content padding15">
    <el-select v-model="cas.company" filterable placeholder="请选择" style="width: 25%;" v-if="this.$partB()">
      <el-option
        v-for="item in companyNameList"
        :key="item.id"
        :label="item.companyName"
        :value="item.id">
      </el-option>
    </el-select>
  </div>
  <div class="bg-content padding15">
    <el-tabs v-model="activeTab" @tab-click="handleClick">
      <el-tab-pane label="公司信息" name="公司信息">
        <company-information v-bind:companyIdTemp="cas.company" :companyNameList="companyNameList"></company-information>
      </el-tab-pane>
      <el-tab-pane label="白名单" name="白名单" v-if="this.$hasPerm('GS001')">
        <ip-info v-bind:companyIdTemp="cas.company"></ip-info>
      </el-tab-pane>
      <el-tab-pane label="公司设置" name="公司设置" v-if="this.$hasPerm('GS002')">
        <company-set v-bind:companyIdTemp="cas.company"></company-set>
      </el-tab-pane>
      <!-- <el-tab-pane label="接口推送" name="接口推送" v-if="this.$hasPerm('GS003')">
        <interface-push v-bind:companyIdTemp="cas.company"></interface-push>
      </el-tab-pane> -->
      <el-tab-pane label="催记推送" name="催记推送" v-if="this.$hasPerm('GS005')">
        <collection-records-push v-bind:companyIdTemp="cas.company"></collection-records-push>
      </el-tab-pane>
      <!-- <el-tab-pane label="定时通知" name="定时通知" v-if="this.$hasPerm('GS004')">
        <notice v-bind:companyIdTemp="cas.company"/>
      </el-tab-pane> -->
      <!-- Cost calculation -->
      <el-tab-pane label="计费设置" name="计费设置" v-if="this.$partB()">
        <billing-set v-bind:companyIdTemp="cas.company"/>
      </el-tab-pane>
      <el-tab-pane label="转人工通道配置" name="转人工通道配置" v-if="this.$partB()">
        <transfer-labor v-bind:companyIdTemp="cas.company" :changeTabe="activeTab"/>
      </el-tab-pane>
    </el-tabs>
  </div>
 </div>
</template>
<script>
import companyInformation from './company_information';
import ipInfo from './ip_info';
import companySet from './company_set';
import interfacePush from './interfacePush';
import notice from './notice';
import billingSet from './billing_set';
import collectionRecordsPush from './collection_records_push';
import transferLabor from './transfer_labor';


export default {
  data() {
    return {
      cas: {
        company: null
      },
      activeTab: '公司信息',
      companyNameList: []
    };
  },
  // 进入页面调用此方法
  mounted() {
    this.getCompanyAll();
  },
  methods: {
    handleClick() {},
    getCompanyAll() {
      this.$ajax({
        url: '/company/getCompanyListJudgeRole',
        method: 'get'
      }).then((res) => {
        console.warn(res);
        this.companyNameList = res.data;
        this.cas.company = res.data[0].id;
      }).catch((error) => {
        this.$message({
          type: 'error',
          message: error.message
        });
      });
    }
  },
  components: {
    companyInformation, ipInfo, companySet, interfacePush, notice, billingSet, collectionRecordsPush, transferLabor
  }
};
</script>



// WEBPACK FOOTER //
// src/page/main/company/index.vue